import dynamic from 'next/dynamic';
import { ModifyEventSummaryProps } from './ModifyEventSummary.types';

export const ModifyEventSummary = dynamic<{ model: ModifyEventSummaryProps }>(() =>
  import('./ModifyEventSummary').then(mod => mod.ModifyEventSummary)
);
